import { Inject, Injectable } from '@angular/core';

import { Observable, filter } from 'rxjs';

import { BackgroundProcessConfig, BACKGROUND_PROCESS_CONFIG } from './background-process-config';
import { IEnvironment, ENV_TOKEN } from '../../models/environment';
import { GlobalErrorHandler } from '../error-handler/error-handler.service';
import { IdentityService } from '../identity/identity.service';
import { ApiBackgroundProcessMessage, BackgroundProcessEnum, ServicesEnum } from '../open-api/open-api-clients';
import { SignalRBaseClientService } from '../signalr/signalr-base-client.service';

@Injectable({ providedIn: 'root' })
export class BackgroundProcessService extends SignalRBaseClientService {

    public progress$: Observable<ApiBackgroundProcessMessage>;

    constructor(
        identityService: IdentityService,
        protected readonly _errorHandler: GlobalErrorHandler,
        @Inject(ENV_TOKEN) env: IEnvironment,
        @Inject(BACKGROUND_PROCESS_CONFIG) private readonly config: BackgroundProcessConfig) {

        super(identityService, _errorHandler, `${ env.apiUrl }/api/signalrhub/backgroundprocesses`);

        this.progress$ = this.getCallbackSource$('backgroundProcessProgress').pipe(
            filter((message: ApiBackgroundProcessMessage) => this._isAllowedProcess(message.services)))
    }

    public onComplete(...processes: BackgroundProcessEnum[]): Observable<ApiBackgroundProcessMessage> {
        return this.progress$.pipe(filter(m => processes.includes(m.process) && m.completed));
    }

    private _isAllowedProcess(process: ServicesEnum): boolean {
        return !this.config.allowedServicess || this.config.allowedServicess.length === 0 ||
            this.config.allowedServicess.includes(process);
    }
}
